import React from "react";
const ErrorComp = () => {
  return (
    <div className="error-page">
      <div className="error-container">
        <img src="img/icon/error.svg" alt="Error icon" />
        <div>
          <h3>Error Loading data!</h3>
          <div>Please contact your administrator</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComp;
